import React from 'react';
import { t } from 'ttag';
import { roundToFive } from '~/lib/time/roundToFive';
import { formatDurationInMinutes } from '~/lib/formatters/duration';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import { TrainingState, useTrainingStore } from '../../state';
import ClockIcon from '../assets/clock.svg';
import { OnboardingStages, useOnboardingStore } from '../Store';

const selector = (s: TrainingState) => s.duration;

export const Ready = () => {
  const { stage, next } = useOnboardingStore();
  const duration = useTrainingStore(selector);
  const durationEstimated = useTrainingStore(s => s.durationEstimated);

  const _round =
    durationEstimated && duration > 0
      ? formatDurationInMinutes(duration)
      : roundToFive(duration);

  return (
    <Flex
      variant="list"
      justifyContent="space-between"
      data-test-id="ready-card"
    >
      <h2>{t`Get ready for the ride`}</h2>
      <Flex variant="center" w="auto" h="auto">
        <ClockIcon />
      </Flex>
      <small>
        {t`This training should take approximately ${_round} depending on your pace. So go get a coffee.`}
      </small>
      <Button
        onClick={next}
        disabled={stage !== OnboardingStages.Ready}
        aria-hidden={stage !== OnboardingStages.Ready}
        data-test-id="next-button"
      >
        {t`Next`}
      </Button>
    </Flex>
  );
};
